<ng-container [formGroup]="parent">
  <ng-container formGroupName="orderDetails">
    <div class="d-flex align-items-end justify-content-between">
      <div
        class="col-6 d-flex align-items-end justify-content-between justPadding12">
        <h3 class="m-0">Details</h3>
        <!-- <div
          class="d-flex justify-content-start pb-1"
          (click)="addContactInformation()"
        >
          <a
            *ngIf="customerBillToObject?.clientAccount"
            class="addNewClient nav-link link-gray"
            ><i class="icon-Add"></i> Add new</a
          >
        </div> -->
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <!-- <div class="col mb-4">
        <div ngbDropdown #contactdropdown="ngbDropdown">
          <div class="form-group has-float-label">
            <input pInputText 
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              formControlName="buyer"
              (focusout)="applyBuyerLengthValidation($event)"
              (click)="onContactList(contactdropdown)"
            />
            <label class="form-label">Buyer</label>
          </div>
          <div
            class="order-dropdown add"
            ngbDropdownMenu
            aria-labelledby="dropdownBasic1"
          >
          <div class="indropdowntable">
              <p-table
                #dt
                [value]="contactLists"
                styleClass="p-datatable-customers order-listing"
                [rowHover]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [paginator]="false"
                [filterDelay]="0"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th class="name">Name</th>
                    <th class="vaccount">Phone</th>
                    <th class="street">Email</th>
                    <th class="city">Purpose</th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-customerList
                  let-rowIndex="rowIndex"
                >
                  <tr
                    class="p-selectable-row mousepointer"
                    (click)="
                      onCustomerSelection(customerList.name, contactdropdown)
                    "
                  >
                    <td class="name mousepointer">{{ customerList.name }}</td>
                    <td class="vaccount mousepointer">
                      {{ customerList.phone }}
                    </td>
                    <td style="width: 100px" class="sname mousepointer">
                      {{ customerList.email }}
                    </td>
                    <td class="city mousepointer">
                      {{ customerList.purpose }}
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="20">No contact found.</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div> -->
        <!-- <div class="col-8 mb-4" *ngIf="orderType == 'all-sales'">
        <div class="title mb-1">Inventory Sales:</div>
        <div class="form-check form-switch">
          <input pInputText 
            class="form-check-input me-2"
            [checked]="false"
            type="checkbox"
            id="tAssumption"
            name="tAssumption"
          />
        </div>
      </div> -->
        <div class="col-6 mb-2" *ngIf="orderType === 'inventory-sales'">
          <div class="title mb-1">Inventory Sales:</div>
          <div class="form-check form-switch">
            <p-toggleSwitch
              id="tAssumption"
              name="tAssumption"
              formControlName="jniSalesInventoryD365" />
          </div>
        </div>
        <div class="">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Client PO number<span *ngIf="isCustomerPoRequiredField"
                >*</span
              ></label
            >
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              formControlName="customerPONumber"
              (focusout)="applyCustomerPoLengthValidation($event)"
              [ngClass]="{ 'has-error': formErrors['customerPONumber'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['customerPONumber']">
              {{ formErrors["customerPONumber"] }}
            </span>
          </div>
        </div>
      </div>

      <div class="col-2 mb-2 align-items-center currency-container d-flex">
        <div class="align-items-end currency-container d-flex w-100">
          <div class="cur-label me-2 text-center">
            <p-checkbox
              formControlName="foreignCurrencyStatus"
              (click)="onCurrencyStatus($event)"
              inputId="foreignCurrencyStatus"
              binary="true" />
            <label for="foreignCurrencyStatus" class="mx-2">Use Alt</label>
          </div>
        </div>
      </div>
      <div class="col-4 mb-2">
        <div class="form-group has-float-label w-100">
          <label class="form-label">sell Currency</label>
          <p-select
            pInputText
            id="currency"
            formControlName="foreignCurrency"
            [options]="currencyList"
            optionLabel="isoCurrencyCodeD365"
            optionValue="isoCurrencyCodeD365"
            [filter]="true"
            [showClear]="true">
          </p-select>
        </div>
      </div>

      <div class="col-6">
        <div class="col mb-2">
          <div class="form-group has-float-label">
            <label class="form-label">Shipping method</label>
            <p-select
              pInputText
              id="currency"
              formControlName="shippingMethod"
              (onChange)="onShippingMethodChange($event)"
              [options]="shippingProductsList"
              optionLabel="modeDescriptionD365"
              optionValue="modeCodeD365"
              [filter]="true"
              [showClear]="true">
            </p-select>
          </div>
        </div>
      </div>

      <div class="col-6 mb-2">
        <div class="form-group has-float-label">
          <label class="form-label">Account</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            formControlName="account"
            [readonly]="isNadelFreightAccount"
            [ngClass]="{
              inputtextgray: isNadelFreightAccount === true,
            }" />
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [isFromOrdersAddNewBuyer]="true"
  [addClientContact]="addClientContact"
  [customerAccountNumber]="customerAccountNumber"
  (isContactAdded)="isContactAdded($event)"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>
